import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const getVideoMediaToken = (assetId) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.MANAGE.GET_VIDEO_MEDIA_TOKEN(assetId)
  );
};

export default getVideoMediaToken;
